import { render } from "./edit-department.vue?vue&type=template&id=74f7d53b"
import script from "./edit-department.vue?vue&type=script&lang=js"
export * from "./edit-department.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__